import React, { Component } from 'react'
import { connect } from 'react-redux'
import { hide as hideMap, changeFloor } from '../actions/map'

import { getPictograms } from '../selectors'

import View from '../components/View'
import ViewHeader from '../components/ViewHeader'
import ViewContainer from '../components/ViewContainer'
import ViewContent from '../components/ViewContent'
import ViewTools from '../components/ViewTools'

import PillTabs from '../components/PillTabs'
import BackLink from '../components/BackLink'
import MapCanvas from  '../components/MapCanvas'
import GarageStart from '../components/GarageStart'
import Legend from '../components/Legend'

import Locale from '../data/localization'
import { nodes } from '../data/data'

import uniq from 'lodash/uniq'

class MapView extends Component {

    handleFloorChange(floor) {
        this.props.dispatch(changeFloor(floor))
    }

    handleNextFloor(floorList) {
        const { floor } = this.props
        let current = floorList.indexOf(floor)

        if (current === -1) {
            current = 0
        }
        this.props.dispatch(changeFloor(floorList[current + 1]))
    }

    render() {
        const { active, floor, from, to, dispatch, path, nodes, floors, polygons, pictograms } = this.props
        const target = { ...nodes[to] }
        const floorList = uniq(path.map(key => nodes[key].floor))
        const paths = floorList
            .map(floor => ({
                path: path.filter(id => nodes[id].floor === floor),
                floor: floor
            }))

        const currentFloor = floor !== null ? floor : floorList[0];

        const pillTabs = floorList.map(floor => ({
            label: Locale.floors[floor],
            value: floor
        }))

        const pictos = pictograms.filter(pictogram => pictogram.floor === currentFloor);

        const currentFloorIndex = floorList.indexOf(currentFloor)
        const nextFloor = currentFloorIndex < floorList.length - 1 ? floorList[currentFloorIndex + 1] : null

        return (
            <View type="MapView" layer={true} active={active}>
                <ViewHeader>
                    <ViewContainer>
                        <BackLink type="light" label={Locale.map.backLink} onClick={() => dispatch(hideMap())} />
                        <strong className="MapView-target">{target.name}</strong>
                    </ViewContainer>
                </ViewHeader>

                <ViewTools>
                    <PillTabs
                        items={pillTabs}
                        current={currentFloor}
                        onChange={::this.handleFloorChange}
                    />
                </ViewTools>

                <ViewContent>
                    {currentFloor === -3 && <GarageStart path={paths.filter(item => item.floor === currentFloor)[0].path} nextFloor={nextFloor} />}
                    {currentFloor !== -3 &&
                        paths
                            .filter(item => item.floor === currentFloor && item.path.length > 1)
                            .map(item => (
                                <MapCanvas
                                    path={item.path.map(nodeId => nodes[nodeId])}
                                    polygons={polygons}
                                    pictograms={pictos}
                                    floor={floors[item.floor]}
                                    lastFloor={floorList.indexOf(currentFloor) === floorList.length - 1}
                                    key={item.floor}
                                    onNextClick={() => this.handleNextFloor(floorList)} />
                            ))
                    }
                    {/* {path.map((nodeId, index) => <div key={nodeId}>{index} {nodes[nodeId].name}</div>)} */}
                    <Legend />
                </ViewContent>
            </View>
        )
    }
}

function mapStateToProps(state) {
    return {
        ...state.ui.map,
        nodes: state.entities.nodes,
        floors: state.entities.floors,
        polygons: state.entities.polygons,
        pictograms: getPictograms(state)
    }
}

export default connect(mapStateToProps)(MapView)


// WEBPACK FOOTER //
// ./containers/MapView.js